/**
 * 68.25 (lane D; decision 156, the owner: "Will also need to figure out telling bots not to do that stuff"): the team's
 * standing order on vehicles, held by the Match — a `vehicles` input like any order, in the input log. `none` keeps the
 * team's bots on foot: the APC loop gives no rides (a ride of its own under way ends, its riders out but the gunner, as at
 * any ride's end), no bot takes a bike, and the commander brings up no gun support. A human's own order (a ride from the
 * table) still goes: the forbid is on the bots' choices. `free` lifts it; nobody setting it, every team is free.
 */
import type { GameState } from '../types';

export type VehicleUse = 'free' | 'none';

/** Whether `team`'s bots are kept on foot. */
export function vehiclesBarred(state: Pick<GameState, 'vehicleUse'>, team: number): boolean {
  return state.vehicleUse?.[team] === 'none';
}

/** The state with `team`'s standing order on vehicles set (`free` drops the entry; the record absent once none is kept). */
export function applyVehicleUse(state: GameState, team: number, use: VehicleUse): GameState {
  const { [team]: _was, ...rest } = state.vehicleUse ?? {};
  const next = use === 'none' ? { ...rest, [team]: 'none' as const } : rest;
  const { vehicleUse: _old, ...base } = state;
  return Object.keys(next).length ? { ...base, vehicleUse: next } : base as GameState;
}
